module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_external_link_white-e77283cea5371173418ebca59e6f5ecb.svg";